<ui-title [title]="'Local User Aliases'"></ui-title>

<ui-alert
	*ngIf="modalAlert.display"
	[title]="modalAlert.title"
	[text]="modalAlert.text"
	(onAction)="modalAlert.cb($event)"
></ui-alert>

<div class="card">
	<div class="card-header">
		User Aliases
		<div class="col-lg-6 float-right">
			<ui-loading [loadingText]="'loading aliases'" [loading]="aliases.loading"></ui-loading>
		</div>
	</div>
	<div class="card-body">

		<ui-table [filters]="true" [chunker]="aliases.chunker" (chunked)="aliases.chunkedData = $event" [headers]="aliases.tableHeaders" [options]="aliases.tableOptions">
			<tr *ngFor="let an of aliases.chunkedData"
			>
				<td>{{ an.System.Name }}</td>
				<td>{{ an.UserNameInSystem }}</td>
				<td>{{ an.SORUser.FirstName }} {{ an.SORUser.LastName }}</td>
				<td>
					<ui-loading [loading]="aliases.deleting[an.Id]" [loadingText]="'deleting'"></ui-loading>
					<button [hidden]="aliases.deleting[an.Id]" class="btn btn-danger btn-sm" (click)="aliases_delete(an)">delete</button>
				</td>
			</tr>
		</ui-table>
	</div>
</div>
<div class="card-separator"></div>
<div class="card">
	<div class="card-header">
		Adding new User Alias
	</div>


	<div class="card-body">

		<div class="alert alert-warning">
			DO NOT map privileged accounts (s-,l-) to normal accounts but INSTEAD override their managers
		</div>
		<ui-loading [loading]="aliases.saving"></ui-loading>
		<form [hidden]="aliases.saving">
			<div class="form-group">
				<label class="col-form-label">
					System
				</label>
				<div>

					<ui-loading [loading]="systems.loading"></ui-loading>
					<select class="form-control" [hidden]="systems.loading" [(ngModel)]="aliases.newAlias.systemId" name="newsystemid">
						<option></option>
						<option *ngFor="let s of systems.data" [value]="s.Id">
							{{ s.Name }}
						</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<label class="col-form-label">
					User Alias in the system
				</label>
				<input class="form-control" [(ngModel)]="aliases.newAlias.username" name="newusername"/>
			</div>
			<div class="form-group mat-autocomplete-large">
				<label class="col-form-label">
					User in Active Directory
				</label>
				<br>

				<mat-form-field>
					<input [formControl]="aliases.newAlias.sorUserIdFormControl"
						   type="text" placeholder="Search" aria-label="Number" matInput [matAutocomplete]="auto">

					<mat-autocomplete panelWidth="'100%'" autoActiveFirstOption #auto="matAutocomplete" [displayWith]="autocompleteDisplayUser">
						<mat-option *ngFor="let item of  aliases.autocomplete$ | async; let index=index" [value]="item">
							{{ item.FirstName }} {{ item.LastName }} ({{ item.Login }})
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
			</div>
			<div class="form-group">
				<label></label>
				<button mat-button class="btn btn-primary" (click)="aliases_save()">add</button>
			</div>
		</form>
	</div>
</div>
